<template>
  <v-simple-table dense>
    <template #default>
      <tbody>
        <tr v-for="(attachment, index) in attachments" :key="index">
          <td>
            <a :href="attachment.file.url" target="_blank">
              {{ attachment.file.name }}
            </a>
          </td>

          <td width="1%" class="no-wrap">
            {{ formatDate(attachment.createdAt) }}
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
export default {
  props: {
    attachments: {
      type: Array,
      required: true,
    },
  },

  methods: {
    formatDate(val) {
      return new Date(val).toLocaleString(undefined, {
        timeZone: "CET",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
  },
};
</script>
